/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {BaseService} from "./base-service";
import {Router} from "@angular/router";
import {AuthenticationService} from "./authentication.service";
import {PingServerService} from "./ping-server.service";
import { Url_Base } from "app/rest-constants";

@Injectable()
export class PingService extends BaseService {
  private pingServerListeners = new Subject<boolean>();
  private continuePinging = true;
  private lastPingTime = null;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private pingServerService: PingServerService
  ) {
    super(router, authenticationService);
  }

  public getPingServerEventListeners(): Subject<boolean> {
    return this.pingServerListeners;
  }

  startPingingServer(): void {
    this.continuePinging = true;

  }

  stopPingingServer(): void {
    this.continuePinging = false;
  }

  pingServerBackgroundThread(): void {
    if (this.continuePinging) {
      this.pingServer();
    }

    setTimeout(() => {
      this.pingServerBackgroundThread()
    }, 10000);
  }

  async pingServer(): Promise<void> {
    if (this.continuePinging) {
      try {
        await this.pingServerService.ping();
        this.pingServerListeners.next(true);
      } catch (error) {
        this.pingServerListeners.next(false);
      }
    }
  }

  getPingServerListener(): Subject<any> {
    return this.pingServerListeners;
  }

  pingServerx(): void {
    this.pingServerListeners.next();
  }
}
